<template>
  <div id="root">
    <h5 v-if="loading" style="text-align:center">
      Loading...
    </h5>
    <h3 v-if="error">
      {{ error }}
      <!-- An error ocurred.
      Try reloading the page or confirming that you were added to Discipleship by a staff member. -->
    </h3>

    <el-row
      type="flex"
      class="row-bg"
      justify="space-around"
      v-if="isOneOfTheseRoles(['regional']) && tableData"
    >
      <el-col :span="21">
        <div class="grid-content make-space-between">
          <h1>
            <el-tooltip
              content="This is live data."
              :open-delay="300"
              placement="top"
            >
              <el-button class="fake-button lg">
                <span style="font-size:2rem;font-weight:normal;">
                  Spiritual Multiplication Table
                </span><i class="el-icon-info" style="margin-left: 5px;" />
              </el-button>
            </el-tooltip>
          </h1>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content" v-if="!error">
          <el-button
            @click="openMetricModal()"
            type="warning"
          >
            How are these numbers calculated? <i class="el-icon-question"></i>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      class="row-bg"
      justify="space-around"
      v-if="isOneOfTheseRoles(
        ['td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary', 'alumni', 'chaplain']
      ) && !isOneOfTheseRoles(['admin']) && tableData"
    >
      <el-col :span="21">
        <div class="grid-content make-space-between">
          <h1>
            <el-tooltip
              content="This is live data."
              :open-delay="300"
              placement="top"
            >
              <el-button class="fake-button lg">
                <span style="font-size:2rem;font-weight:normal;">
                  {{ tableData.campus }}
                </span><i class="el-icon-info" style="margin-left: 5px;" />
              </el-button>
            </el-tooltip>
          </h1>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content" v-if="!error">
          <el-button
            @click="openMetricModal()"
            type="warning"
          >
            How are these numbers calculated? <i class="el-icon-question">
            </i>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <div class="container" v-if="isOneOfTheseRoles(['regional']) && tableData">
      <div class="row header-row">
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Campus
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          BSPx1
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          BSPx4
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Growing Disciples
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Commissioned Disciples
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          All SLBS
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          Active SLBS
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          Growing Disciple Makers
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          Disciple Makers
        </div>
      </div>
      <div class="row header-row">
        <div class="col-md-2 col-lg-2 col-sm-12">
          <b><i>Totals</i></b>
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ this.totals.cumulative_bspx1 }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ this.totals.cumulative_bspx4 }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ this.totals.growing_disciples }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ this.totals.commissioned_disciples }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ this.totals.student_leaders }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ this.totals.active_slbs }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ this.totals.growing_disciple_makers }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ this.totals.disciple_makers }}
        </div>
      </div>
      <div class="row" v-for="campus in tableData" :key="campus.campus">
        <div class="col-md-2 col-lg-2 col-sm-12">
          {{ campus.campus }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ campus.cumulative_bspx1 }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ campus.cumulative_bspx4 }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ campus.growing_disciples }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ campus.commissioned_disciples }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ campus.student_leaders }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ campus.active_slbs }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ campus.growing_disciple_makers }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ campus.disciple_makers }}
        </div>
      </div>
    </div>
    <div
      class="container"
      v-if="isOneOfTheseRoles(
        ['td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary', 'alumni', 'chaplain']
      ) && !isOneOfTheseRoles(['admin']) && tableData"
    >
      <div class="row header-row">
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          BSPx1
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          BSPx4
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Growing Disciples
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Commissioned Disciples
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          All SLBS
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          Active SLBS
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Growing Disciple Makers
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          Disciple Makers
        </div>
      </div>
      <div class="row">
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ tableData.cumulative_bspx1 }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ tableData.cumulative_bspx4 }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ tableData.growing_disciples }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ tableData.commissioned_disciples }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ tableData.student_leaders }}
        </div>
        <div class="col-md-1 col-lg-1 col-sm-12 center">
          {{ tableData.active_slbs }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ tableData.growing_disciple_makers }}
        </div>
        <div class="col-md-2 col-lg-2 col-sm-12 center">
          {{ tableData.disciple_makers }}
        </div>
      </div>
    </div>
    <MM :show="modals.metricModalOpen" @close="modals.metricModalOpen = false" />
  </div>
</template>

<script>
import {
    mapState
} from 'vuex';
import apiService from '../../repositories/apiService';
import MetricModal from '../../components/SpiritualMultiplication/MetricModal';

export default {
    data() {
        return {
            title: 'Spiritual Multiplication Table (live data)',
            tableData: null,
            loading: false,
            error: '',
            totals: {},
            modals: {
                metricModalOpen: false
            }
        };
    },
    components: {
        MM: MetricModal
    },
    computed: {
        ...mapState({
            role: (state) => state.role,
        }),
    },
    watch: {
        role() {
            this.getTable();
        },
        tableData() {
            this.getTotals();
        }
    },
    methods: {
        getTable() {
            this.loading = true;
            if (this.isOneOfTheseRoles([
                'regional', 'td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary', 'alumni', 'chaplain'
            ])) {
                apiService
                    .get('/spiritual_multiplication/')
                    .then((response) => {
                        if (this.isOneOfTheseRoles([
                            'td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary', 'alumni', 'chaplain'
                        ]) && !this.isOneOfTheseRoles(['admin'])) {
                            const [campus] = response.data.tableData;
                            this.tableData = campus;
                        } else {
                            this.tableData = response.data.tableData;
                        }
                        this.$store.commit('setError', '');
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.$store.commit('setError', error);
                        this.loading = false;
                        this.error = error.response.data.message;
                    });
            }
        },
        openMetricModal() {
            this.modals.metricModalOpen = !this.modals.metricModalOpen;
        },
        getTotals() {
            // Initialize sum
            this.totals.cumulative_bspx1 = 0;
            this.totals.cumulative_bspx4 = 0;
            this.totals.growing_disciples = 0;
            this.totals.commissioned_disciples = 0;
            this.totals.student_leaders = 0;
            this.totals.active_slbs = 0;
            this.totals.growing_disciple_makers = 0;
            this.totals.disciple_makers = 0;

            // Iterate through each object in the array
            this.tableData.forEach((obj) => {
                // Add the value of 'active_slbs' field to the sum
                this.totals.cumulative_bspx1 += obj.cumulative_bspx1 || 0;
                this.totals.cumulative_bspx4 += obj.cumulative_bspx4 || 0;
                this.totals.growing_disciples += obj.growing_disciples || 0;
                this.totals.commissioned_disciples += obj.commissioned_disciples || 0;
                this.totals.student_leaders += obj.student_leaders || 0;
                this.totals.active_slbs += obj.active_slbs || 0;
                this.totals.growing_disciple_makers += obj.growing_disciple_makers || 0;
                this.totals.disciple_makers += obj.disciple_makers || 0;
            });
        }
    },
    created() {
        this.getTable();
    },
};

</script>

<style scoped>
.row {
    margin-bottom: 10px;
    border-bottom: 1px solid lightgray;
}
.header-row {
    font-weight: bold;
    border-bottom: 1px solid gray;
}
.fake-button {
  border: none;
  background-color: transparent;
  font-weight: bold;
  color: black;
  cursor: default;
}
.lg {
  font-size: 1rem;
  padding-left: 0;
  vertical-align: top;
}
.el-icon-info {
  font-size: .75rem;
}
</style>
